import { useState, useContext, useEffect, useMemo, memo } from "react";
import { useSettingModal } from "../../../hooks/Context";
import css3 from "../Approvals/css/approval-table.module.css";
import {
  MdOutlineArrowBackIosNew as LBtn,
  MdOutlineArrowForwardIos as RBtn,
} from "react-icons/md";
import { FiMoreHorizontal as MoreIcon } from "react-icons/fi";
import { convertTimetoString } from "../../../helperFunction";
interface PaymentTableProps {}

const DATA_PER_PAGE = 10;

const PaymentTable = (props: any) => {
  const [activeData, setActiveData] = useState<any>([]);
  const [pageData, setPageData] = useState<any>([]);
  const [pageArr, setPageArr] = useState<any>([]);
  const [showMore, setShowMore] = useState<boolean>(false);
  const [showIndex, setShowIndex] = useState<any>(null);
  const [showSpan, setShowSpan] = useState<boolean>(false);
  const [spanIndex, setSpanIndex] = useState<null | number>(null);
  const data: any = props?.data?.reportItems;
  const pageCount = props?.data?.PageCount;
  const currentPage = props?.currentPage;
  const setCurrentPage = props?.setCurrentPage;

  const handlePrevous = () => {
    if (currentPage === 1) return;
    setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage === pageCount) return;
    setCurrentPage(currentPage + 1);
  };

  const handleMore = (index: number) => {
    if (index == showIndex) {
      setShowIndex(null);
      setShowMore(false);
      return;
    }
    setShowIndex(index);
    setShowMore(true);
  };
  const handleSpan = (index: number) => {
    if (index == spanIndex) {
      setSpanIndex(null);
      setShowSpan(false);
      return;
    }
    setSpanIndex(index);
    setShowSpan(true);
  };

  const handleViewDetails = (data: any) => {};

  const handleApproveOrDecline = (data: any) => {};

  useEffect(() => {
    if (data && data.length > 0) {
      let i = 0;
      let arr = [];
      for (i = 1; i <= pageCount; i++) {
        arr.push(i);
      }

      setPageArr(arr);
      setPageData(data.slice(0, DATA_PER_PAGE));
    }
  }, [data]);

  return (
    <div className={css3.container}>
      <>
        <div style={{ gridTemplateColumns: `repeat(8,.9fr)` }}>
          <div>Applicant ID</div>
          <div>Full Name</div>
          <div>Payment-Channel</div>
          <div>Payment-Reference</div>
          <div>Amount</div>
          <div>Payment-Date</div>
          <div>Purpose-Payment</div>
          <div>Payment-Status</div>
        </div>
        <div>
          {data &&
            data.length > 0 &&
            data?.map((eData: any, index: number): any => (
              <div
                key={index}
                style={{ gridTemplateColumns: `repeat(8,.9fr)` }}
              >
                <div onClick={() => handleSpan(index)}>{eData.ApplicantId}</div>
                <div onClick={() => handleSpan(index)}>{eData.FullName}</div>
                <div onClick={() => handleSpan(index)}>
                  {eData.PaymentChannel}
                </div>
                <div onClick={() => handleSpan(index)}>
                  {eData.PaymentReference}
                </div>
                <div onClick={() => handleSpan(index)}>{eData.Amount}</div>
                <div onClick={() => handleSpan(index)}>
                  {convertTimetoString(eData.PaymentDate, 0)}
                </div>
                <div onClick={() => handleSpan(index)}>
                  {eData.PaymentAction || "N/A"}
                </div>
                <div onClick={() => handleSpan(index)}>
                  {eData.PaymentStatus}
                </div>
              </div>
            ))}
        </div>
        <div className={css3.pagination}>
          <div>
            <button
              className={`${css3.lBtn} ${css3.btn}`}
              onClick={handlePrevous}
            >
              <LBtn />
            </button>
            {pageArr &&
              pageArr.length > 0 &&
              pageArr.map((ePage: number, index: number) => {
                if (index + 1 <= 3 && currentPage <= 3)
                  return (
                    <span
                      style={
                        ePage == currentPage
                          ? {
                              backgroundColor: "var(--activeP-back)",
                              color: "var(--white-color)",
                            }
                          : {}
                      }
                      key={ePage}
                      onClick={() => setCurrentPage(ePage)}
                    >
                      {ePage}
                    </span>
                  );

                if (index + 1 == currentPage)
                  return (
                    <span
                      style={
                        ePage == currentPage
                          ? {
                              backgroundColor: "var(--activeP-back)",
                              color: "var(--white-color)",
                            }
                          : {}
                      }
                      key={ePage}
                      onClick={() => setCurrentPage(ePage)}
                    >
                      {ePage}
                    </span>
                  );

                if (
                  index + 1 >= pageArr.length - 2 &&
                  currentPage >= pageArr.length - 2
                )
                  return (
                    <span
                      style={
                        ePage == currentPage
                          ? {
                              backgroundColor: "var(--activeP-back)",
                              color: "var(--white-color)",
                            }
                          : {}
                      }
                      key={ePage}
                      onClick={() => setCurrentPage(ePage)}
                    >
                      {ePage}
                    </span>
                  );

                if (index + 1 == pageArr.length)
                  return (
                    <>
                      <>...</>
                      <span
                        style={
                          ePage == currentPage
                            ? {
                                backgroundColor: "var(--activeP-back)",
                                color: "var(--white-color)",
                              }
                            : {}
                        }
                        key={ePage}
                        onClick={() => setCurrentPage(ePage)}
                      >
                        {ePage}
                      </span>
                    </>
                  );

                if (index == 0)
                  return (
                    <>
                      <span
                        style={
                          ePage == currentPage
                            ? {
                                backgroundColor: "var(--activeP-back)",
                                color: "var(--white-color)",
                              }
                            : {}
                        }
                        key={ePage}
                        onClick={() => setCurrentPage(ePage)}
                      >
                        {ePage}
                      </span>
                      <>...</>
                    </>
                  );
              })}
            <button className={`${css3.rBtn} ${css3.btn}`} onClick={handleNext}>
              <RBtn />
            </button>
          </div>
        </div>
      </>
    </div>
  );
};

export default PaymentTable;
